import { IPagination } from "../interfaces/pagination";

export const ITEMS_PER_PAGE = 20;

export const REPORTS_ALLOWED_FILE_EXTENSIONS = ["application/pdf", "image/*", ".csv", ".xlsx"];

export const PREFERENCE_TYPES = [
	"Ingredient Categories",
	"Sub Categories",
	"Form",
	"Storage Conditions",
	"Processes",
	"Dietary/Functional",
	"Allergens",
	"Harvest Type",
	"Season",
	"Regional",
	"Cost"
];

export enum availableSubscriptionPlans {
	supplier = "supplier",
	growth = "growth",
	fresh = "fresh",
	group = "group",
	enterprise = "enterprise",
	guava = "guava"
}

export enum trialSubscriptionPlans {
	fresh = "fresh",
	growth = "growth"
}
export enum subscriptionInterval {
	month = "month",
	year = "year"
}

export interface ISubscriptionDetails {
	subscriptionName: availableSubscriptionPlans;
	subscriptionDetails: string[];
	subscriptionPrice: number;
	subscriptionInterval: string;
	subscriptionDescription: string;
	dividerColor?: string;
}

export const SUBSCRIPTION_OPTIONS: { [index: string]: ISubscriptionDetails } = {
	supplier: {
		subscriptionName: availableSubscriptionPlans.supplier,
		subscriptionDetails: [
			"1 user",
			"Supplier profile",
			"Get discovered by buyers"
		],
		subscriptionPrice: 60,
		subscriptionInterval: subscriptionInterval.year,
		subscriptionDescription: "Market your ingredients to CPG brands",
		dividerColor: "#3f65f1"
	},
	fresh: {
		subscriptionName: availableSubscriptionPlans.fresh,
		subscriptionDetails: [
			"1 user",
			"1 brand",
			"50 searches/mo",
			"10 analyses/mo"
		],
		subscriptionPrice: 199,
		subscriptionInterval: subscriptionInterval.month,
		subscriptionDescription: "Get started with 1 user and 1 brand",
		dividerColor: "#7c4aa9"
	},
	growth: {
		subscriptionName: availableSubscriptionPlans.growth,
		subscriptionDetails: [
			"2 users",
			"3 brands",
			"200 searches/mo",
			"50 analyses/mo"
		],
		subscriptionPrice: 499,
		subscriptionInterval: subscriptionInterval.month,
		subscriptionDescription: "Support growth with 2 users and 3 brands",
		dividerColor: "#e85a73"
	},
	group: {
		subscriptionName: availableSubscriptionPlans.group,
		subscriptionDetails: [
			"10 users",
			"10 brands",
			"500 searches/mo",
			"100 analyses/mo"
		],
		subscriptionPrice: 999,
		subscriptionInterval: subscriptionInterval.month,
		subscriptionDescription: "Drive performance with 10 users and 10 brands",
		dividerColor: "#0ed7ac"
	},
	enterprise: {
		subscriptionName: availableSubscriptionPlans.enterprise,
		subscriptionDetails: [
			"50 users",
			"Unlimited brands",
			"Unlimited searches",
			"Custom reporting"
		],
		subscriptionPrice: 1999,
		subscriptionInterval: subscriptionInterval.month,
		subscriptionDescription: "Automate innovation with 50 users and unlimited brands",
		dividerColor: "#f4a850"
	},
	guava:{
		subscriptionName: availableSubscriptionPlans.guava,
		subscriptionDetails: [
			"Custom analytics",
			"API access",
			"White-label options"
		],
		subscriptionPrice: 1299,
		subscriptionInterval: subscriptionInterval.month,
		subscriptionDescription: "Guava Dashboard",
		dividerColor: "#5063f4ff"
	}
};

export const PAGINATION_META_DEFAULT: IPagination = {
	page: 1, // current page
	size: 20, // total items per page
	pages: 0, // total pages
	total: 0 // total items
};
